/** Estructura de la consola autenticada: barra lateral de navegación + cabecera con el operador. */
import type { ReactElement } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { logout, useSession } from "../api/session";
import { toast } from "./Toast";

const NAV_ITEMS = [
  { to: "/organizations", label: "Organizaciones" },
  { to: "/modules", label: "Módulos" },
  { to: "/audit", label: "Auditoría" },
  { to: "/health", label: "Salud" },
  { to: "/cuenta", label: "Mi cuenta" },
];

const OPERATOR_ROLE_LABEL: Record<string, string> = {
  owner: "Dueño",
  support: "Soporte",
  billing: "Facturación",
};

export function Layout(): ReactElement {
  const { operator } = useSession();
  const navigate = useNavigate();

  async function handleLogout(): Promise<void> {
    await logout();
    toast.info("Sesión cerrada.");
    navigate("/login", { replace: true });
  }

  return (
    <div className="shell shell-app">
      <aside className="sidebar">
        <div className="sidebar-brand">Continnua</div>
        <nav aria-label="Navegación principal">
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink to={item.to} className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      <div className="main-column">
        <header className="topbar">
          <div>
            {operator && (
              <span className="operator-info">
                {operator.fullName} · {OPERATOR_ROLE_LABEL[operator.role] ?? operator.role}
              </span>
            )}
          </div>
          <button type="button" className="button-secondary" onClick={() => void handleLogout()}>
            Cerrar sesión
          </button>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
